import { Component, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from "@angular/core";

import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";
import { OrderHistoryDetail, OrderIPN } from "libs/xplat/core/src/lib/models/admin.model";
import moment from "moment";

@Component({
  selector: "myp-user-order-list",
  templateUrl: "user-order-list.component.html",
  standalone: false,
})
export class UserOrderListComponent extends BaseComponent implements OnInit {
  @Input() orders: any[];
  public filteredOrders: any[];
  private searchTerm: string = "";
  private filterFn: (order: any) => boolean;
  constructor(
    userService: UserService,
    public appService: AppService
  ) {
    super(userService);
    // Pre-compile the filter function
    this.filterFn = this.createFilterFunction();
  }

  ngOnInit() {
    this.filterOrders();
  }

  private createFilterFunction(): (order: any) => boolean {
    // Create a more predictable function that the browser can optimize
    return (order: any) => {
      if (!order) return false;

      const searchTerm = this.searchTerm;
      if (!searchTerm) return true;

      // Check reference number
      if (order.reference_number?.toString().toLowerCase().includes(searchTerm)) {
        return true;
      }

      // Check order history ID
      if (order.idorder_history?.toString().toLowerCase().includes(searchTerm)) {
        return true;
      }

      // Check details
      if (order.details?.length) {
        for (const detail of order.details) {
          if (detail.title?.toLowerCase().includes(searchTerm) || detail.product_key?.toLowerCase().includes(searchTerm)) {
            return true;
          }
        }
      }

      return false;
    };
  }

  public filtering: boolean;
  filterOrders(args?: string) {
    this.filtering = !!args;
    this.searchTerm = args?.toLowerCase() || "";
    // Use the pre-compiled filter function
    this.filteredOrders = this.orders.filter(this.filterFn);
  }

  sortOrders() {
    if (!this.filteredOrders?.length) return;

    const sorter = (a: any, b: any) => {
      if (this.appService.sortBy === "date") {
        const dateA = a.order_date;
        const dateB = b.order_date;

        if (!dateA && !dateB) return 0;
        if (!dateA) return this.appService.sortDirection === "asc" ? -1 : 1;
        if (!dateB) return this.appService.sortDirection === "asc" ? 1 : -1;

        const momentA = moment(dateA);
        const momentB = moment(dateB);

        if (momentA.isSame(momentB)) return 0;
        return this.appService.sortDirection === "asc" ? (momentA.isBefore(momentB) ? -1 : 1) : momentA.isBefore(momentB) ? 1 : -1;
      } else {
        const refA = a.reference_number?.toString().toLowerCase() || "";
        const refB = b.reference_number?.toString().toLowerCase() || "";

        if (refA === refB) return 0;
        return this.appService.sortDirection === "asc" ? (refA < refB ? -1 : 1) : refA < refB ? 1 : -1;
      }
    };

    this.filteredOrders.sort(sorter);
  }

  loadInvoiceUrl(order_ipn: OrderIPN | undefined) {
    if (!order_ipn) return;

    return order_ipn.data?.object?.hosted_invoice_url || order_ipn.invoiceURL;
  }

  parseTotalPaid(order_ipn: OrderIPN | undefined) {
    if (!order_ipn) return 0;

    return order_ipn.data?.object?.amount_paid ? Number(order_ipn.data.object.amount_paid) / 100 : order_ipn.invoiceChargeAmount || 0;
  }

  parseCurreny(order_ipn: OrderIPN | undefined) {
    if (!order_ipn) return "USD";

    return order_ipn.data?.object?.currency?.toUpperCase() || order_ipn.currency?.toUpperCase() || "USD";
  }
}
